function stripHtmlTags(text) {
  var tags = /<[^>]+>/g
  return text.replace(tags, ' ')
}

export default stripHtmlTags
